import React, {Component, ReactNode} from 'react'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import MeetingCommentDetail from './model/MeetingCommentDetail'
import {judgeAuthorityCheck, NatAsyncCallFunction} from '../../__NoAutomatedTests/common/util/Natutil'
import {MeetingRepositoryForResident} from './MeetingRepositoryForResident'
import {Nullable, Optional} from '../../app/TypeHelpers'
import NewMeetingComment from './model/NewMeetingComment'
import MeetingCommentComponent from './components/MeetingCommentComponent'
import {CommentReactedUser} from './model/MeetingComment'
import MeetingCommentInputForm, {InputError} from './components/MeetingCommentInputForm'
import {MeetingCommentFile} from './model/MeetingCommentFile'
import DeletedCommentDetail from './model/DeletedCommentDetail'
import MeetingCommentReply from './model/MeetingCommentReply'
import {Box} from '@mui/material'
import {DisplayItemDividerForPageTop} from '../../styledComponents/DisplayItem'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../styledComponents/Constants'
import {currentMedia} from '../../styledComponents/ResponsiveConvenience'
import UpdateMeetingComment from './model/UpdateMeetingComment'
import MeetingCommentEditDialog from './components/MeetingCommentEditDialog'
import {PlainLinkStyledBackButton} from '../../styledComponents/Button'
import {SubmitNewCommentReplyProcedure} from './model/SubmitNewCommentReplyProcedure'
import {SubmitUpdateCommentProcedure} from './model/SubmitUpdateCommentProcedure'
import {SubmitUpdateCommentReplyProcedure} from './model/SubmitUpdateCommentReplyProcedure'
import {ViewOnlyModeMessage} from '../reservations/components/CommonStyle'
import {HKConstants} from '../../HKConstants'
import {ContentBody} from './AssocDirectorResidentCommon'
import ResponsiveDialog from '../shared/ResponsiveDialog'
import {CommentNotificationData} from './model/CommentNotificationData'
import NatCurrentDateTimeRepo
    from '../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    NatGetCurrentDateTime,
} from '../../__NoAutomatedTests/components/currentDateTime/repository/NatGetCurrentDateTime'
import {Location} from 'react-router-dom'

interface LocationState {
    previousPageUrlStack: string[]
}

interface Props {
    condominiumCd: string
    meetingId: number
    replySourceId: number
    meetingRepoForResident: MeetingRepositoryForResident
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location<LocationState>
}

interface State {
    commentDetail: Nullable<MeetingCommentDetail | DeletedCommentDetail>
    isCommentInputOpen: boolean
    newContent: string
    newCommentFileList: MeetingCommentFile[]
    commentInputError: Optional<InputError>
    commentEditError: Optional<InputError>
    errorCommentFileNameList: string[]
    errorCommentId: Nullable<number>
    isOpenCommentEditDialog: boolean
    editContent: string
    editCommentFileList: MeetingCommentFile[]
    deleteFileNumberList: number[]
    editCommentId: number
    editCommentVersion: number
    havePostCommentAuthority: boolean
    isLoadCompleted: boolean
    currentDateTime: string
}

class ResidentCommentReplyPage extends Component<Props & ResidentPagePropsSet, State> {
    submitNewCommentReplyProcedure: SubmitNewCommentReplyProcedure
    submitUpdateCommentProcedure: SubmitUpdateCommentProcedure
    submitUpdateCommentReplyProcedure: SubmitUpdateCommentReplyProcedure

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)

        this.state = {
            commentDetail: null,
            isCommentInputOpen: false,
            newContent: '',
            newCommentFileList: [],
            commentInputError: undefined,
            commentEditError: undefined,
            errorCommentFileNameList: [],
            errorCommentId: null,
            isOpenCommentEditDialog: false,
            editContent: '',
            editCommentFileList: [],
            deleteFileNumberList: [],
            editCommentId: 0,
            editCommentVersion: 0,
            havePostCommentAuthority: false,
            isLoadCompleted: false,
            currentDateTime: '',
        }

        this.handleClickRegisterReplyButton = this.handleClickRegisterReplyButton.bind(this)

        this.submitNewCommentReplyProcedure = new SubmitNewCommentReplyProcedure(
            (inputError) => {
                this.setState({commentInputError: inputError})
            },
            this.props.meetingRepoForResident,
            this.props.eventEmitter,
            this.props.navigate,
        )

        this.submitUpdateCommentProcedure = new SubmitUpdateCommentProcedure(
            (inputError) => {
                this.setState({commentEditError: inputError})
            },
            this.props.meetingRepoForResident,
            this.props.eventEmitter,
            this.props.navigate,
        )

        this.submitUpdateCommentReplyProcedure = new SubmitUpdateCommentReplyProcedure(
            (inputError) => {
                this.setState({commentEditError: inputError})
            },
            this.props.meetingRepoForResident,
            this.props.eventEmitter,
            this.props.navigate,
        )
    }

    async componentDidMount(): Promise<void> {
        try {
            const commentDetail = await this.getComment()
            if (commentDetail === null) {
                return
            }

            const currentTimeResponse: Nullable<NatGetCurrentDateTime> = await NatAsyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(
                    this.props.currentDateTimeRepo), this.props.navigate)
            if (currentTimeResponse === null || currentTimeResponse.details === null) {
                return
            }

            this.setState({
                commentDetail,
                havePostCommentAuthority: judgeAuthorityCheck(HKConstants.CMN.AUTH.POST_COMMENT_ASSOC_DIRECTOR),
                currentDateTime: currentTimeResponse.details.currentDateTime,
            })
        } finally {
            this.setState({isLoadCompleted: true})
        }
    }

    async getComment(): Promise<Nullable<MeetingCommentDetail | DeletedCommentDetail>> {
        const {meetingRepoForResident, condominiumCd, meetingId, replySourceId, navigate} = this.props

        let commentDetail: Nullable<MeetingCommentDetail | DeletedCommentDetail> = null
        await this.props.eventEmitter.showLoading()
        try {
            commentDetail = await NatAsyncCallFunction(
                meetingRepoForResident.getCommentDetail.bind(
                    meetingRepoForResident,
                    condominiumCd,
                    meetingId,
                    replySourceId,
                ), navigate)
        } finally {
            this.props.eventEmitter.closeLoading()
        }
        return commentDetail
    }

    handleClickOpenCommentInputButton = (): void => {
        this.setState({isCommentInputOpen: true})
    }

    handleChangeCommentInput = (
        content: string,
        commentFileList: MeetingCommentFile[],
        deleteFileNumberList: number[],
        inputError?: InputError,
    ): void => {
        this.setState({
            newContent: content,
            newCommentFileList: commentFileList,
            commentInputError: inputError,
        })
    }

    handleClickCloseCommentInputButton = (): void => {
        this.setState({
            newContent: '',
            newCommentFileList: [],
            isCommentInputOpen: false,
            commentInputError: undefined,
            errorCommentFileNameList: [],
            errorCommentId: null,
        })
    }

    async handleClickRegisterReplyButton(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const {condominiumCd, meetingId, replySourceId} = this.props
            const {newContent, newCommentFileList} = this.state

            const commentId = await this.submitNewCommentReplyProcedure.submit(
                condominiumCd,
                meetingId,
                replySourceId,
                new NewMeetingComment(newContent),
                newCommentFileList,
            )
            if (!commentId) {
                return
            }
            const commentNotificationData: CommentNotificationData = {
                meetingId: meetingId,
                commentId: commentId,
            }
            this.props.meetingRepoForResident.sendCommentNotification(
                condominiumCd,
                commentNotificationData,
            ).then(r => null)

            const comment = await this.getComment()
            if (comment === null) {
                return
            }

            const fileUploadError = this.submitNewCommentReplyProcedure.getFileUploadError()
            this.setState({
                commentDetail: comment,
                isCommentInputOpen: false,
                newContent: '',
                newCommentFileList: [],
                commentInputError: undefined,
                errorCommentFileNameList: fileUploadError?.errorFileNameList ?? [],
                errorCommentId: fileUploadError?.commentId ?? null,
            })
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleClickReaction = async (commentId: number, isReaction: boolean): Promise<void> => {
        const {meetingRepoForResident, condominiumCd, meetingId, navigate} = this.props
        const {commentDetail} = this.state

        if (commentDetail === null || commentDetail instanceof DeletedCommentDetail) {
            return
        }

        const commentReactedUserList = await NatAsyncCallFunction(
            meetingRepoForResident.updateCommentReaction.bind(
                meetingRepoForResident,
                condominiumCd,
                meetingId,
                commentId,
                isReaction), navigate)
        if (commentReactedUserList === null) {
            return
        }

        const newCommentDetail = new MeetingCommentDetail(
            commentDetail.meetingCommentId,
            commentDetail.content,
            commentDetail.user,
            commentDetail.updateDatetime,
            commentReactedUserList,
            commentDetail.attachmentList,
            commentDetail.isYou,
            commentDetail.version,
            commentDetail.commentReplyList,
        )

        this.setState({commentDetail: newCommentDetail})
    }

    handleClickReplyReaction = async (commentReplyId: number, isReaction: boolean): Promise<void> => {
        const {meetingRepoForResident, condominiumCd, meetingId, replySourceId, navigate} = this.props
        const {commentDetail} = this.state

        if (commentDetail === null) {
            return
        }

        let commentReactedUserList: Nullable<CommentReactedUser[]> = null
        commentReactedUserList = await NatAsyncCallFunction(
            // @ts-ignore
            meetingRepoForResident.updateCommentReplyReaction.bind(
                meetingRepoForResident,
                condominiumCd,
                meetingId,
                replySourceId,
                commentReplyId,
                isReaction), navigate)
        if (commentReactedUserList === null) {
            return
        }

        const newCommentReplyList = commentDetail.commentReplyList
            .map(reply => {
                if (reply instanceof MeetingCommentReply &&
                    reply.meetingCommentId === commentReplyId &&
                    commentReactedUserList) {
                    return new MeetingCommentReply(
                        reply.meetingCommentId,
                        reply.replySourceId,
                        reply.content,
                        reply.user,
                        reply.updateDatetime,
                        commentReactedUserList,
                        reply.attachmentList,
                        reply.isYou,
                        reply.version,
                    )
                }
                return reply
            })

        let newCommentDetail: MeetingCommentDetail | DeletedCommentDetail
        if (commentDetail instanceof DeletedCommentDetail) {
            newCommentDetail = new DeletedCommentDetail(
                commentDetail.meetingCommentId,
                commentDetail.message,
                newCommentReplyList,
            )
        } else {
            newCommentDetail = new MeetingCommentDetail(
                commentDetail.meetingCommentId,
                commentDetail.content,
                commentDetail.user,
                commentDetail.updateDatetime,
                commentDetail.commentReactedUserList,
                commentDetail.attachmentList,
                commentDetail.isYou,
                commentDetail.version,
                newCommentReplyList,
            )
        }

        this.setState({commentDetail: newCommentDetail})
    }

    handleClickDeleteComment = async (commentId: number): Promise<void> => {
        const {eventEmitter, meetingRepoForResident, condominiumCd, meetingId, navigate} = this.props

        await eventEmitter.showLoading()
        try {
            const result = await NatAsyncCallFunction(
                meetingRepoForResident.deleteComment.bind(
                    meetingRepoForResident,
                    condominiumCd,
                    meetingId,
                    commentId,
                ), navigate)
            if (result === null) {
                return
            }
        } finally {
            eventEmitter.closeLoading()
        }

        const comment = await this.getComment()
        if (comment === null) {
            return
        }

        this.setState({
            commentDetail: comment,
            errorCommentFileNameList: [],
            errorCommentId: null,
        })
    }

    handleClickDeleteCommentReply = async (commentReplyId: number): Promise<void> => {
        const {eventEmitter, meetingRepoForResident, condominiumCd, meetingId, replySourceId, navigate} = this.props

        await eventEmitter.showLoading()
        try {
            const result = await NatAsyncCallFunction(
                meetingRepoForResident.deleteCommentReply.bind(
                    meetingRepoForResident,
                    condominiumCd,
                    meetingId,
                    replySourceId,
                    commentReplyId,
                ), navigate)
            if (result === null) {
                return
            }
        } finally {
            eventEmitter.closeLoading()
        }

        const comment = await this.getComment()
        if (comment === null) {
            return
        }

        this.setState({
            commentDetail: comment,
            errorCommentFileNameList: [],
            errorCommentId: null,
        })
    }

    handleClickCommentEditButton = (
        commentId: number,
        version: number,
        content: string,
        commentFileList: MeetingCommentFile[],
    ): void => {
        this.setState({
            isOpenCommentEditDialog: true,
            editCommentId: commentId,
            editCommentVersion: version,
            editContent: content,
            editCommentFileList: commentFileList,
            deleteFileNumberList: [],
        })
    }

    handleClickCommentEditCloseButton = (): void => {
        this.setState({
            isOpenCommentEditDialog: false,
            editCommentId: 0,
            editCommentVersion: 0,
            editContent: '',
            editCommentFileList: [],
            deleteFileNumberList: [],
            commentEditError: undefined,
        })
    }

    handleChangeCommentEdit = (
        content: string,
        commentFileList: MeetingCommentFile[],
        deleteFileNumberList: number[],
        inputError?: InputError,
    ): void => {
        this.setState({
            editContent: content,
            editCommentFileList: commentFileList,
            deleteFileNumberList: deleteFileNumberList,
            commentEditError: inputError,
        })
    }

    handleClickCommentEditSubmitButton = async (): Promise<void> => {
        if (this.props.replySourceId === this.state.editCommentId) {
            await this.commentEdit()
        } else {
            await this.commentReplyEdit()
        }
    }

    handleClickBackButton = (): void => {
        const {navigate, replySourceId, location} = this.props
        const onePreviousPageUrl: string = location.state?.previousPageUrlStack.pop() ?? ''
        const twoPreviousPageUrl: Optional<string> = location.state?.previousPageUrlStack.pop()
        navigate(
            onePreviousPageUrl,
            {
                state: {
                    scrollTargetCommentId: replySourceId,
                    previousPageUrl: twoPreviousPageUrl,
                },
            },
        )
    }

    commentEdit = async (): Promise<void> => {
        await this.props.eventEmitter.showLoading()
        try {
            const {condominiumCd, meetingId} = this.props
            const {
                editContent,
                editCommentFileList,
                deleteFileNumberList,
                editCommentId,
                editCommentVersion,
            } = this.state

            const result = await this.submitUpdateCommentProcedure.submit(
                condominiumCd,
                meetingId,
                editCommentId,
                new UpdateMeetingComment(editContent, deleteFileNumberList, editCommentVersion),
                editCommentFileList,
            )
            if (!result) {
                return
            }

            const comment = await this.getComment()
            if (comment === null) {
                return
            }

            const fileUploadError = this.submitUpdateCommentProcedure.getFileUploadError()
            this.setState({
                commentDetail: comment,
                isOpenCommentEditDialog: false,
                editContent: '',
                editCommentFileList: [],
                deleteFileNumberList: [],
                editCommentId: 0,
                editCommentVersion: 0,
                commentEditError: undefined,
                errorCommentFileNameList: fileUploadError?.errorFileNameList ?? [],
                errorCommentId: fileUploadError?.commentId ?? null,
            })
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    commentReplyEdit = async (): Promise<void> => {
        await this.props.eventEmitter.showLoading()
        try {
            const {condominiumCd, meetingId, replySourceId} = this.props
            const {
                editContent,
                editCommentFileList,
                deleteFileNumberList,
                editCommentId,
                editCommentVersion,
            } = this.state

            const result = await this.submitUpdateCommentReplyProcedure.submit(
                condominiumCd,
                meetingId,
                replySourceId,
                editCommentId,
                new UpdateMeetingComment(editContent, deleteFileNumberList, editCommentVersion),
                editCommentFileList,
            )
            if (!result) {
                return
            }

            const comment = await this.getComment()
            if (comment == null) {
                return
            }

            const fileUploadError = this.submitUpdateCommentReplyProcedure.getFileUploadError()
            this.setState({
                commentDetail: comment,
                isOpenCommentEditDialog: false,
                editContent: '',
                editCommentFileList: [],
                deleteFileNumberList: [],
                editCommentId: 0,
                editCommentVersion: 0,
                commentEditError: undefined,
                errorCommentFileNameList: fileUploadError?.errorFileNameList ?? [],
                errorCommentId: fileUploadError?.commentId ?? null,
            })
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    render(): ReactNode {
        const {
            commentDetail,
            isCommentInputOpen,
            newContent,
            newCommentFileList,
            commentInputError,
            havePostCommentAuthority,
            isLoadCompleted,
        } = this.state

        return (<>
            <PlainLinkStyledBackButton type={'button'} onClick={this.handleClickBackButton}>
                戻る
            </PlainLinkStyledBackButton>
            <Box height={'14px'}/>
            <DisplayItemDividerForPageTop/>
            <Box height={'15px'}/>
            {
                isLoadCompleted &&
                commentDetail !== null &&
                <ContentBody>
                    {
                        !havePostCommentAuthority &&
                        <>
                            <ViewOnlyModeMessage>コメントを返信する権限がありません。</ViewOnlyModeMessage>
                            <Box height={'15px'}/>
                        </>
                    }
                    <WideWhiteArea>
                        <Box height={'15px'}/>
                        {this.renderComment(commentDetail)}
                        <Box height={'15px'}/>
                        {
                            havePostCommentAuthority &&
                            <>{
                                isCommentInputOpen ?
                                    <MeetingCommentInputForm
                                        submitButtonLabel={'返信する'}
                                        onClickSubmitButton={this.handleClickRegisterReplyButton}
                                        onClickCancelButton={this.handleClickCloseCommentInputButton}
                                        onChange={this.handleChangeCommentInput}
                                        content={newContent}
                                        placeholder={'返信を入力...'}
                                        commentFileList={newCommentFileList}
                                        deleteFileNumberList={[]}
                                        inputError={commentInputError}
                                    />
                                    :
                                    <ReplyCommentButton onClick={this.handleClickOpenCommentInputButton}>
                                        返信を入力...
                                    </ReplyCommentButton>
                            }
                            </>
                        }
                        <Box height={'15px'}/>
                    </WideWhiteArea>
                </ContentBody>
            }
        </>)
    }

    renderComment(commentDetail: MeetingCommentDetail | DeletedCommentDetail): ReactNode {
        const {condominiumCd, meetingId} = this.props
        const {
            isOpenCommentEditDialog,
            editContent,
            editCommentFileList,
            deleteFileNumberList,
            commentEditError,
            errorCommentId,
            errorCommentFileNameList,
            havePostCommentAuthority,
        } = this.state
        let errorFileNameList = commentDetail.meetingCommentId === errorCommentId ?
            errorCommentFileNameList : undefined
        return (<>
            <MeetingCommentComponent
                condominiumCd={condominiumCd}
                meetingId={meetingId}
                meetingComment={commentDetail}
                onClickReaction={this.handleClickReaction}
                onClickCommentDelete={this.handleClickDeleteComment}
                onClickEditButton={this.handleClickCommentEditButton}
                errorFileNameList={errorFileNameList}
                havePostCommentAuthority={havePostCommentAuthority}
                currentDatetime={this.state.currentDateTime}
            />
            <Box height={'30px'}/>
            {
                commentDetail.commentReplyList.map((comment, index) => {
                    errorFileNameList = comment.meetingCommentId === errorCommentId ?
                        errorCommentFileNameList : undefined
                    const showVerticalDivider =
                        commentDetail.commentReplyList.length !== index + 1 || havePostCommentAuthority
                    return <div key={`reply-${index}`}>
                        <MeetingCommentComponent
                            condominiumCd={condominiumCd}
                            meetingId={meetingId}
                            meetingComment={comment}
                            onClickReaction={this.handleClickReplyReaction}
                            onClickCommentDelete={this.handleClickDeleteCommentReply}
                            onClickEditButton={this.handleClickCommentEditButton}
                            errorFileNameList={errorFileNameList}
                            havePostCommentAuthority={havePostCommentAuthority}
                            verticalDivider={showVerticalDivider}
                            currentDatetime={this.state.currentDateTime}
                        />
                    </div>
                })
            }
            <CommentEditDialog
                open={isOpenCommentEditDialog}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
            >
                <MeetingCommentEditDialog
                    onClickSubmitButton={this.handleClickCommentEditSubmitButton}
                    onClickCloseButton={this.handleClickCommentEditCloseButton}
                    onChange={this.handleChangeCommentEdit}
                    content={editContent}
                    commentFileList={editCommentFileList}
                    deleteFileNumberList={deleteFileNumberList}
                    commentInputError={commentEditError}
                />
            </CommentEditDialog>
        </>)
    }
}

export default createResidentPage(ResidentCommentReplyPage)

const WideWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 15px;
  box-sizing: border-box;
`

const ReplyCommentButton = styled.button`
  border: ${Colors.AccentLight} 1px solid;
  border-radius: 4px;
  padding: 8px 10px;
  box-sizing: border-box;
  width: 100%;

  font-size: ${FontSize.Body};
  color: ${Colors.Placeholder};
  font-weight: ${FontWeights.Normal};
  line-height: 1.5;
  text-align: start;
  background-color: ${Colors.Surface};
`

const CommentEditDialog = styled(ResponsiveDialog)`
  ${currentMedia.greaterThan('pc')`
    & .MuiDialog-paper {
        width: 580px;
    }
`}
`
